import { PlatformLocation } from '@angular/common';
import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, take } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GuardService } from '../service/guard.service';
import { ResultpageService } from '../service/resultpage.service';
import { Result } from '../type/result_type';

@Injectable({
  providedIn: 'root',
})
export class PagesGuard {
  private token!: string;
  private activityToken!: string;

  constructor(
    private resultpageService: ResultpageService,
    private router: Router,
    private route: ActivatedRoute,
    private pLocation: PlatformLocation,
    private guardService: GuardService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.checkToken();
  }

  checkToken() {
    if (this.guardService.checkKreditcenter()) {
      return true;
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.token = urlParams.get('t') ?? '';
    this.activityToken = urlParams.get('activityToken') ?? '';

    if (this.token) {
      return this.resultpageService.getResult(this.token).pipe(
        take(1),
        catchError((err) => {
          if (err.status === 403) {
            this.router.navigate(['/', 'birthdaycheck'], {
              replaceUrl: true,
            });
          }
          throw 'error in source!! ';
        }),
        map((data: Result) => {
          return true;
        })
      );
    } else if (this.activityToken) {
      return true;
    } else {
      this.router.navigate(['/', 'test']);
      return false;
    }
  }
}
